// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"gallery-modal_wrapper__2P13g","galleryBox":"gallery-modal_galleryBox__3px36","close":"gallery-modal_close__oPsrV"};